import DropdownButton from '@/components/ui/Buttons/DropdownButton';
import DropdownSelect from '@/components/ui/DropdownSelect';
import { FieldErrors, FieldNames } from '../util/constants';
import { RefObject } from 'react';

export type ProgramFormatDropdownProps = {
  onChangeCallback: (value: string) => void;
  onShowError: (show: boolean) => void;
  formatValue?: string | null;
  programFormatOptions: {
    label: string;
    value: string;
  }[];
  errors?: FieldErrors | null;
  programFormatRef: RefObject<HTMLDivElement>;
};

const ProgramFormatDropdown = ({
  onChangeCallback,
  onShowError,
  programFormatOptions,
  errors,
  formatValue,
  programFormatRef
}: ProgramFormatDropdownProps) => {
  return (
    <div className="relative [&>button]:h-[70px]" ref={programFormatRef}>
      <DropdownSelect
        button={({ isOpen, value, dropdownSide, ...props }) => (
          <DropdownButton
            state={isOpen ? 'open' : 'closed'}
            label={value}
            dropdownError={errors?.[FieldNames.PROGRAM_FORMAT]}
            dropdownSide={dropdownSide}
            {...props}
          />
        )}
        label="Program format"
        placeholder="Select a program format"
        options={programFormatOptions}
        value={formatValue ?? ''}
        onValueChange={value => !!onChangeCallback && onChangeCallback(value)}
        menuStyle="form-field"
        showError={show => !!onShowError && onShowError(show)}
        required
      />
    </div>
  );
};
export default ProgramFormatDropdown;
